import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  progressBar: {
    background: "#D0D5DD",
    borderRadius: "8px",
    overflow: "hidden",
    height: "35px",
    position: "relative",
    width: "100%",
  },
  text: {
    top: "50%",
    transform: "translateY(-50%)",
    left: "13px",
    position: "absolute",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 12,
    lineHeight: "24px",
    color: "#FFFFFF",
  },
  progress: {
    height: "100%",
    background: "#32D583",
    opacity: "1 !important",
    width: (props: { value: number | string }) => (props?.value ? `${props?.value}%` : `0%`),
  },
}));

export default styles;
